// extracted by mini-css-extract-plugin
export default {"extraAction":"S3L3VHKGZ9Xeegx9O44W","title":"Q7PBRmfyTY6FTlNekeE2"};